import React from 'react';
import { LogoutRounded as LogoutRoundedIcon } from '@mui/icons-material';
import { Box, List, ListItemButton, Tooltip, Typography } from '@mui/material';
import { guaranteesLayoutStyles } from '../../styles.ts';
import CompactNavigationItem from './CompactNavigationItem.tsx';
import type { ICompactNavigationSectionProps } from './types.ts';

const CompactNavigationSection: React.FC<ICompactNavigationSectionProps> = ({
  activeCompactGroupSegment,
  currentPath,
  menuItems,
  onGroupHoverChange,
  onGroupOpen,
  onLogout,
  onNavigate,
}) => {
  return (
    <>
      <Box sx={guaranteesLayoutStyles.menuCompactBody}>
        <List disablePadding sx={guaranteesLayoutStyles.menuCompactList}>
          {menuItems.map((item) => (
            <CompactNavigationItem
              key={item.segment}
              activeCompactGroupSegment={activeCompactGroupSegment}
              currentPath={currentPath}
              item={item}
              onGroupHoverChange={onGroupHoverChange}
              onGroupOpen={onGroupOpen}
              onNavigate={onNavigate}
            />
          ))}
        </List>
      </Box>

      <Box sx={guaranteesLayoutStyles.compactFooter}>
        <Tooltip title="Вийти" placement="left">
          <ListItemButton
            onClick={onLogout}
            sx={guaranteesLayoutStyles.menuCompactItemButton(false)}
          >
            <Box sx={guaranteesLayoutStyles.menuCompactBadge(false)}>
              <LogoutRoundedIcon sx={guaranteesLayoutStyles.menuCompactIcon(false)} />
            </Box>
            <Box sx={guaranteesLayoutStyles.menuCompactLabelRow}>
              <Typography sx={guaranteesLayoutStyles.menuCompactLabel(false)}>Вийти</Typography>
            </Box>
          </ListItemButton>
        </Tooltip>
      </Box>
    </>
  );
};

export default CompactNavigationSection;
